import { Stack, type StackProps } from '@mui/material';

export const FormStack: React.FC<StackProps> = ({ children, ...restProps }) => (
  <Stack
    spacing={3}
    {...restProps}
  >
    {children}
  </Stack>
);
